import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  createPartnerRequest
} from "../../services/partnerRequest";

const Partner = () => {
  const [form, setForm] = useState({
    name: "",
    address: "",
    mobile: "",
    pincode: ""
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    let newErrors = {};

    if (!form.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(form.email)) {
        newErrors.email = "Enter a valid email address";
      }
    }

    if (!form.mobile) {
      newErrors.mobile = "Mobile number is required";
    } else if (!/^[6-9]\d{9}$/.test(form.mobile)) {
      newErrors.mobile = "Enter valid 10-digit mobile number";
    }


    if (!form.address.trim()) {
      newErrors.address = "Address is required";
    }

    if (!form.pincode) {
      newErrors.pincode = "Pincode is required";
    } else if (!/^\d{6}$/.test(form.pincode)) {
      newErrors.pincode = "Enter valid 6-digit pincode";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (
      !form.name ||
      !form.email ||
      !form.mobile ||
      !form.address ||
      !form.pincode
    ) {
      toast.warning("All fields are required");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        name: form.name,
        email: form.email,
        mobile: form.mobile,
        address: form.address,
        pincode: form.pincode,
      };

      const response = await createPartnerRequest(payload);

      if (response?.status === 200) {
        toast.success(
          response.message || "Partner request created successfully"
        );

        // ✅ clear form
        setForm({
          name: "",
          email: "",
          mobile: "",
          address: "",
          pincode: "",
        });
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrapper}>
      {/* LEFT CONTENT */}
      <div style={styles.left}>
        <h1 style={styles.title}>
          Double your earning <br /> from today!
        </h1>

        <div style={styles.line}></div>

        <p style={styles.subtitle}>
          Join <span style={styles.highlight}>India’s No. 1</span> NanoPulse wala Pathology Management Software
        </p>

        <ul style={styles.list}>
          <li>
            👍 Become Referral Partner &{" "}
            <span style={styles.highlight}>Earn ₹50,000+</span> per month
          </li>
          <li>
            👍 Become NanoPulse Partner with 7 days training and{" "}
            <span style={styles.highlight}>Earn ₹2,00,000+</span> per month
          </li>
          <li>
            👍 Start your own business with{" "}
            <span style={styles.highlight}>Zero Investment</span>
          </li>
        </ul>
      </div>

      {/* RIGHT FORM */}
      <div style={styles.formCard}>
        <div style={styles.formHeader}>
          Sign Up to Become NanoPulse Partner
        </div>

        <form onSubmit={handleSubmit} style={styles.formBody}>
          <input
            type="text"
            name="name"
            placeholder="Name "
            value={form.name}
            onChange={handleChange}
            style={styles.input}
          />
          {errors.name && <p style={styles.error}>{errors.name}</p>}

          <input
            type="text"
            name="email"
            placeholder="Email "
            value={form.email}
            onChange={handleChange}
            style={styles.input}
          />
          {errors.email && <p style={styles.error}>{errors.email}</p>}


          <input
            type="text"
            name="mobile"
            placeholder=" Mobile No."
            value={form.mobile}
            onChange={handleChange}
            style={styles.input}
          />
          {errors.mobile && <p style={styles.error}>{errors.mobile}</p>}

          <input
            type="text"
            name="address"
            placeholder="Address"
            value={form.address}
            onChange={handleChange}
            style={styles.input}
          />
          {errors.address && <p style={styles.error}>{errors.address}</p>}

          <input
            type="text"
            name="pincode"
            placeholder="Pincode"
            value={form.pincode}
            onChange={handleChange}
            style={styles.input}
          />
          {errors.pincode && <p style={styles.error}>{errors.pincode}</p>}

          <button
            type="button"
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? (
              <div style={styles.btnLoaderWrapper}>
                <div style={styles.loader}></div>
                Submitting...
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Partner;

const styles = {
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "80px 100px",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #2f66b1, #2f66b1)",
    color: "#fff",
  },

  left: {
    width: "55%",
  },

  title: {
    fontSize: "48px",
    fontWeight: "500",
    lineHeight: "1.2",
  },

  line: {
    width: "60px",
    height: "4px",
    background: "#ffd400",
    margin: "20px 0",
  },

  subtitle: {
    fontSize: "20px",
    marginBottom: "20px",
  },

  highlight: {
    color: "#ffd400",
    fontWeight: "600",
  },

  list: {
    listStyle: "none",
    padding: 0,
    lineHeight: "2",
    fontSize: "18px",
  },

  formCard: {
    width: "350px",
    background: "#fff",
    borderRadius: "10px",
    overflow: "hidden",
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
  },

  formHeader: {
    background: "#ffbf00",
    padding: "25px",
    fontWeight: "600",
    textAlign: "center",
    color: "#000",
  },

  formBody: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
  },

  input: {
    padding: "12px",
    marginBottom: "5px",
    borderRadius: "25px",
    border: "1px solid #ccc",
    outline: "none",
  },

  error: {
    color: "red",
    fontSize: "12px",
    marginBottom: "10px",
    marginLeft: "10px",
  },

  button: {
    marginTop: "15px",
    padding: "12px",
    borderRadius: "25px",
    border: "none",
    background: "#009688",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
  },
  loader: {
    width: "18px",
    padding: "4px",
    aspectRatio: "1",
    borderRadius: "50%",
    background: "#000",
    WebkitMask:
      "conic-gradient(#0000 10%,#000), linear-gradient(#000 0 0) content-box",
    mask:
      "conic-gradient(#0000 10%,#000), linear-gradient(#000 0 0) content-box",
    WebkitMaskComposite: "source-out",
    maskComposite: "subtract",
    animation: "spinLoader 1s infinite linear",
  },

  btnLoaderWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
  },
};